import { NgClass } from '@angular/common';
import {
    Component,
    inject,
    Input,
    OnInit,
    signal,
    WritableSignal,
} from '@angular/core';
import { ControlContainer, ReactiveFormsModule } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { TranslateService } from '@ngx-translate/core';
import { ElementWithOptionsModel } from '../../../models/clientsform/element-with-options';
import { LocalizationService } from '../../../services/localization.service';
import { TranslationComponent } from '../../translation/translation.component';

@Component({
    selector: 'apcam-radio-element',
    imports: [
        MatRadioModule,
        NgClass,
        ReactiveFormsModule,
        TranslationComponent,
    ],
    templateUrl: './radio-element.component.html',
    styleUrl: './radio-element.component.scss',
    viewProviders: [
        {
            provide: ControlContainer,
            useFactory: () => inject(ControlContainer, { skipSelf: true }),
        },
    ],
})
export class RadioElementComponent implements OnInit {
    @Input({ required: true })
    public formcontrolName!: string;

    @Input({ required: true })
    public inputConfig!: ElementWithOptionsModel;

    protected radioId: WritableSignal<string> = signal('');
    private readonly controlContainer = inject(ControlContainer);
    private readonly localizationService = inject(LocalizationService);
    private readonly translateService = inject(TranslateService);

    protected get defaultLang() {
        return this.localizationService.defaultLanguage;
    }

    protected get errorMessage() {
        const control = this.controlContainer.control?.get([
            this.formcontrolName,
        ]);
        return control?.hasError('required') && control.touched
            ? this.translateService.instant('shared.validation.required')
            : '';
    }

    ngOnInit(): void {
        this.radioId.set(this.formcontrolName + '-radio-group');
    }
}
